<template>
  <div class="app">
    <AppHeader userName="userName" :userRole="userRole" />
    <div class="app-body">
      <Sidebar></Sidebar>
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <!--<AppAside/>-->
    </div>
    <AppFooter></AppFooter>
    <EventModal></EventModal>
    <FaqModal></FaqModal>
    <AddonsModal></AddonsModal>
    <HistoryModal></HistoryModal>
    <ModalChangeOrderDetail></ModalChangeOrderDetail>
    <ModalInfo></ModalInfo>
    <ModalEditEventDetail></ModalEditEventDetail>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import nav from '../_nav';
import DashCard from '../components/DashCards';
import appStart from '../_dash';
import EventModal from '../components/modal/Modal';
import FaqModal from '../components/modal/FaqModal';
import AddonsModal from '../components/modal/AddonsModal';
import HistoryModal from '../components/modal/HistoryModal';
import ModalChangeOrderDetail from '../components/modal/ModalChangeOrderDetail';
import ModalInfo from '../components/modal/ModalInfo';
import ModalEditEventDetail from '../components/modal/ModalEditEventDetail.vue';

import {
  Header as AppHeader,
  Sidebar,
  Aside as AppAside,
  Footer as AppFooter,
  Breadcrumb
} from '../components/commons';

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    DashCard,
    EventModal,
    FaqModal,
    AddonsModal,
    HistoryModal,
    ModalChangeOrderDetail,
    ModalInfo,
    ModalEditEventDetail
  },
  data () {
    return {
      userRole: nav.userRole,
      userName: nav.userName,
      dashCards: appStart.items
    };
  },
  computed: {
    name () {
      return this.$route.name;
    },
    list () {
      return this.$route.matched;
    }
  },
  mounted () {
    this.$store.dispatch('ACTION_GET_EVENT_COUNT');
  }
};
</script>



// WEBPACK FOOTER //
// Full.vue?140300d2